var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "epf-filter-select-with-input col-12 col-md-4 col-lg-3",
      class: _vm.additionalClass,
    },
    [
      _c("div", { staticClass: "epf-filter-select-with-input__title" }, [
        _vm._v(_vm._s(_vm.filterConfig.title)),
      ]),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          options: _vm.availableOptions,
          value: _vm.selectedOption,
          components: { Deselect: _vm.Deselect },
          disabled: _vm.disabled,
        },
        on: { input: _vm.selectOption },
        scopedSlots: _vm._u([
          {
            key: "open-indicator",
            fn: function () {
              return [
                _c("div", {
                  staticClass: "vs__open-indicator icon icon--arrow-down",
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }